import { Link } from "react-router-dom";
import { CalendarClock, ArrowRight } from "lucide-react";
import { useServices } from "@/lib/services";
import { PayStatus } from "@/components/avisos/PayStatus";

export const ServiceDueCard = () => {
  const { items } = useServices();
  const hot = items.filter((i) => i.status.alert || i.status.state === "paid");
  if (!hot.length) return null;
  return (
    <div data-testid="service-due-card" className="rounded-2xl border border-orange-500/40 bg-orange-500/[0.06] p-5">
      <div className="mb-3 flex items-center justify-between gap-2">
        <h3 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-orange-200"><CalendarClock className="h-4 w-4" /> Vencimentos de serviços</h3>
        <Link to="/avisos" data-testid="service-due-card-open" className="inline-flex items-center gap-1 text-xs font-semibold text-orange-300 hover:text-orange-200">Ver avisos <ArrowRight className="h-3.5 w-3.5" /></Link>
      </div>
      <div className="space-y-2">
        {hot.map((it) => (
          <div key={it.id} data-testid={`service-due-${it.id}`} className="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-xl border border-[#1F293D] bg-[#0F141F] px-3 py-2">
            <span className="w-full text-sm font-semibold text-white sm:w-56">{it.label}{it.name ? <span className="ml-1.5 font-mono text-xs text-slate-500">{it.name}</span> : null}</span>
            <PayStatus it={it} compact />
          </div>
        ))}
      </div>
    </div>
  );
};
